<template>
  <div class="commonProgress">
    <ul class="commonProgressList">
      <li
        v-for="step in steps"
        :key="step.name"
        :style="{ width: `${100 / steps.length}%` }"
        :class="[
          'commonProgressItem',
          { visited: step.visited, active: step.active },
        ]"
      >
        {{ step.name }}
      </li>
    </ul>

    <div v-if="showBackLink" class="commonBack">
      <tk-link class="commonBackLink" @click.prevent="$emit('go-back')">
        <tk-svg-icon icon="prev" />
        ホテル選択に戻る
      </tk-link>
    </div>
  </div>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon'
import TkLink from '../../atoms/TkLink/TkLink'

export default {
  name: 'TkProgressBar',
  components: {
    TkSvgIcon,
    TkLink,
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    showBackLink: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@ota-frontend/ui/src/scss/components/TkProgressBar.scss';
</style>
